import React from 'react';
import { Container } from 'react-bootstrap';
import ReportsDashboard from './ReportsDashboard';

const ReportsPage = () => {
  return (
    <Container fluid className="p-0">
      <ReportsDashboard />
    </Container>
  );
};

export default ReportsPage;